import { useState } from 'react';
import LogoLabel from 'components/logo-label';
import {
  ContainerLanding,
  ContentWrapper,
  ImageContainerMain,
  ImageContainerMainMB,
  ImageMB,
  RowWrapper,
  TextSubTitle,
  TextTitle,
  TitleContent,
} from './components';
import imgBackground from 'assets/images/haggling.png';
import localizedStrings from 'localization/en';
import { ContentIntro } from './ContentIntro';
import { FormStartChallenge } from 'components/form-start-challenge/FormStartChallenge';

export const HagglingLandingMainSection = () => {
  const [start, setStart] = useState(false);
  const handleStartChallenge = () => setStart(true);

  return (
    <ContainerLanding>
      <ImageContainerMainMB>
        <ImageMB 
          src={imgBackground} 
          alt='Illustration representing negotiation and haggling skills development' 
        />
      </ImageContainerMainMB>

      <TitleContent role="banner">
        <LogoLabel />
        <TextTitle role="heading" aria-level={1}>
          {localizedStrings.hagglingLanding.title}
        </TextTitle>
        <TextSubTitle role="heading" aria-level={2}>
          The Easiest Negotiation Tactic You Will Ever Learn
        </TextSubTitle>
      </TitleContent>

      <RowWrapper>
        <ImageContainerMain />
        <ContentWrapper>
          {start ? (
            <FormStartChallenge setStart={setStart} enrollmentCode='09888' />
          ) : (
            <ContentIntro start={handleStartChallenge} />
          )}
        </ContentWrapper>
      </RowWrapper>


    </ContainerLanding>
  );
};


